module.exports = __webpack_public_path__ + "static/media/contract_template_p3.52ff42e3.jpg";